import { IconClose } from '@belong/icons';
import { ButtonBase } from '@belong/ui';
import { MaintenanceRecurrenceDetailModel } from 'api/models';
import { MaintenanceRecurrenceHeaderActions } from 'pages/Accounts/Components/maintenance-recurrence/components/maintenance-recurrence-header-actions';

type MaintenanceRecurrenceNavBarProps = {
  onClosePress: () => void;
  isResident?: boolean;
  // Nullable to match the hook that ultimately supplies it: a rejected fetch
  // leaves the recurrence unset while the page has already stopped loading.
  task: MaintenanceRecurrenceDetailModel | null;
  isSubtask?: boolean;
};

export const MaintenanceRecurrenceNavBar = ({
  onClosePress,
  isResident,
  task,
  isSubtask,
}: MaintenanceRecurrenceNavBarProps) => {
  return (
    <div className="flex items-center justify-between px-0 py-xs md:px-2sm">
      <div>
        <MaintenanceRecurrenceHeaderActions
          isResident={isResident}
          task={task}
          isSubtask={isSubtask}
        />
      </div>

      <ButtonBase className="p-xs sm:p-sm" onClick={onClosePress}>
        <IconClose height={16} />
      </ButtonBase>
    </div>
  );
};
